/*@ngInject*/
const AccordionButtonController = function ($rootScope, $scope, $element, coreConstant) {

    this.$onInit = function () {
        $element.addClass('accordionButton');

        if (this.hasChildren && this.isOpen) {
            $element.addClass('open');
        }
    };

    this.onAccordionButtonClick = function () {
        if (!this.disableUserInteraction) {
            if (this.hasChildren) {
                if (this.isOpen) {
                    $element.removeClass('open');
                } else {
                    $element.addClass('open');
                }

                this.isOpen = !this.isOpen;
            }

            this.notifyAccordionButtonClick({value: this.value});

            if (this.isOpen) {
                $rootScope.$broadcast(coreConstant.event.ACCORDION_BUTTON_OPENED, {value: this.value});
            }
        }
    };

    this.displayCustomIcon = function () {
        return !_.isNil(this.customIcon);
    };

    this.onCustomIconClick = function (event) {
        event.stopImmediatePropagation();
        this.notifyCustomIconClick();
    };

    this.onCustomButtonClick = function (event) {
        event.stopImmediatePropagation();
        this.notifyCustomButtonClick();
    };

    this.onRequiredIndicatorClicked = function (event) {
        event.stopImmediatePropagation();
        this.onRequiredFieldCountClick();
    };

    $scope.$on(coreConstant.event.ACCORDION_BUTTON_OPENED, (event, params) => {
        if (this.closeOtherAccordionsOnOpen && this.value !== params.value) {
            $element.removeClass('open');
            this.isOpen = false;
        }
    });

    $scope.$on(coreConstant.event.CLOSE_ACCORDION_BUTTON, (event, params) => {
        if (this.value === params.value) {
            $element.removeClass('open');
            this.isOpen = false;
        }
    });

    $scope.$on(coreConstant.event.OPEN_ACCORDION_BUTTON, (event, params) => {
        if (this.value === params.value) {
            $element.addClass('open');
            this.isOpen = true;
            $rootScope.$broadcast(coreConstant.event.ACCORDION_BUTTON_OPENED, {value: this.value});
        }
    });
};

angular.module('umCore')
    .controller('accordionButtonController', AccordionButtonController);
